import React from "react";
import styled from "styled-components";
import { CalendarIcon, EditIcon } from "../components/icon";

const BlogPostContainer = styled.div`
  max-width: 100%;
  box-sizing: border-box;
  padding: 1rem;
  background-color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;

const PostImage = styled.img`
  width: 100%;
  height: auto;
  margin-bottom: 24px;

  @media screen and (max-width: 768px) {
    margin-bottom: 20px;
  }
`;

const PostTitle = styled.h2`
  font-family: "Sora";
  font-size: 18px;
  font-weight: 600;
  color: #302e2e;
  margin-bottom: 12px;

  @media screen and (max-width: 768px) {
    font-size: 15px;
  }
`;

const PostDescription = styled.p`
  font-size: 1rem;
  color: #514e4e;

  @media screen and (max-width: 768px) {
    font-size: 13px;
  }
`;

const SeeMoreLink = styled.a`
  color: #007bff;
  font-size: 0.9rem;
  text-decoration: none;
  margin: 24px 0px;

  &:hover {
    text-decoration: underline;
  }
`;

const BlogFooter = styled.div`
  margin-top: 24px;
  display: flex;
  gap: 16px;
`;

const BlogFooterTxt = styled.span`
  font-size: 14px;
  color: #302e2e;
  display: flex;
  gap: 9px;
  border-width: 9px;

  @media (max-width: 768px) {
    font-size: 12px;

  }
`;

const BlogPost = ({ post }) => {
  const truncateDescription = (description, maxLength = 109) => {
    return description.length > maxLength
      ? description.slice(0, maxLength) + "..."
      : description;
  };

  return (
    <BlogPostContainer>
      <PostImage src={post.imagePath} alt={post.title} />
      <PostTitle>{post.title}</PostTitle>
      <PostDescription>{truncateDescription(post.description)}</PostDescription>
      <SeeMoreLink href={`/blog/${post._id}`}>See more</SeeMoreLink>
      <BlogFooter>
        <BlogFooterTxt border="1">
          <EditIcon />
          Safe Net
        </BlogFooterTxt>
        <div style={{ width: "1px" ,backgroundColor:"#99A1AA"}}></div>
        {post?.date && (
          <BlogFooterTxt>
            <CalendarIcon />
            {post.date}
          </BlogFooterTxt>
        )}
      </BlogFooter>
    </BlogPostContainer>
  );
};

export default BlogPost;
